<h1 mat-dialog-title>Rozpoczęcie płatności jest niemożliwe</h1>

<mat-card-content>
  <div>
    Rozpoczęcie płatności jest niemożliwe, gdy druga osoba posiadająca dostęp do opłaty próbuje wykonać płatność.
  </div>
</mat-card-content>

<mat-dialog-actions align="start">
  <button color="primary" mat-raised-button matDialogClose>Zamknij</button>
</mat-dialog-actions>
